import React, { memo } from 'react';
import { mutationTypes } from './mutationUtils';
import ExplanationMutation from './ExplanationMutation';
import { lowercaseSoftConditionalMutations } from './softMutations';
import TableForListSubItem from './TableForListSubItem';
import ListParagraph from './ListParagraph';
import ExplanationSubTitle from './ExplanationSubTitle';

const ExplanationAdjectiveMutation = () => {
  return (
    <ExplanationMutation lowercaseMutations={lowercaseSoftConditionalMutations} mutationType={mutationTypes.SOFT_CONDITIONAL}>
      <>
        <ExplanationSubTitle>
          Feminine singular and Masculine plural of persons (except -où)
        </ExplanationSubTitle>
        <ul>
          <li>
            <TableForListSubItem
              className={'bolden-first-letter'}
              pairs={[
                [ 'kaer', 'gaer' ],
                [ 'kentañ', 'gentañ' ],
                [ 'koant', 'goant' ],
                [ 'kozh', 'gozh' ],
                [ 'paour', 'baour' ],
                [ 'pinvidik', 'binvidik' ],
                [ 'plijus', 'blijus' ],
                [ 'taer', 'daer' ],
              ]}
              getLabelForValue={
                (value) => (`...-l/n/m/r/v/a/e/i/o/u ${value}`)
              }
            />
          </li>
          <li>
            <TableForListSubItem pairs={[
              [ 'glas', 'c\'hlas' ],
              [ 'gwenn', 'wenn' ],
              [ 'gwirion', 'wirion' ],
              [ 'bihan', 'vihan' ],
              [ 'bras', 'vras' ],
              [ 'brav', 'vrav' ],
              [ 'brezhonek', 'vrezhonek' ],
              [ 'du', 'zu' ],
              [ 'diwezhañ', 'ziwezhañ' ],
              [ 'mat', 'vat' ],
            ]}
            />
          </li>
          <li>
            <TableForListSubItem pairs={[
              [ 'Tad-kozh', 'Mamm-gozh' ],
              [ 'Yec\'hed mat!', 'Chañs vat!' ],
              [ 'Tadoù kozh', 'Studieren gozh' ],
              [ 'Bretoned kozh', 'Kendirvi gozh' ],
              [ 'Paotred pinvidik', 'C\'hoarierien binvidik' ],
              [ 'Tud trist', 'Bugale drist' ],
            ]}
            />
          </li>
          <li>
            <ListParagraph>
              Ur vantell c'hlas<br />
              Un daol wenn<br />
              Ur vag vras<br />
              Ur roc'h zu<br />
              Ur verc'h vat<br />
            </ListParagraph>
          </li>
        </ul>
        <ExplanationSubTitle>
          Masculine singular exceptions
        </ExplanationSubTitle>
        <ul>
          <li>
            <TableForListSubItem pairs={[
              [ 'Aer', 'aer domm' ],
              [ 'Amzer', 'amzer vrav' ],
              [ 'Avel', 'avel greñv' ],
              [ 'C\'hwezh', 'c\'hwezh vat (but c\'hwezh kreñv!)' ],
              [ 'C\'hoari', 'c\'hoari gaer' ],
              [ 'Lur', 'ul lur gig' ],
              [ 'Revr', 'revr verr; daou revr dev' ],
              [ 'Re', 'daou re votoù' ],
            ]}
            />
            {/*revr (cul) : berr → revr verr (cul court, qui a les jambes courtes) ;
              tev → daou revr dev (deux gros culs)<br />*/}
            {/*re (paire) : botoù → daou re votoù (deux paires de chaussures)<br />*/}
          </li>
        </ul>
      </>
    </ExplanationMutation>
  );
};

export default memo(ExplanationAdjectiveMutation);
